"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _articleListing = _interopRequireDefault(require("../styles/article-listing.css"));
var _articleCards = _interopRequireDefault(require("./article-cards"));
var _articleListing2 = _interopRequireDefault(require("./article-listing.props/article-listing.defaultProps"));
var _articleListing3 = _interopRequireDefault(require("./article-listing.props/article-listing.propTypes"));
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var ArticleListing = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ArticleListing, _React$Component);
  function ArticleListing() {
    return _React$Component.apply(this, arguments) || this;
  }
  ArticleListing.resourceType = function resourceType() {
    return 'ArticleListing_1_0_0';
  };
  var _proto = ArticleListing.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData;

    // first we select the data from the larger query coming through
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _articleListing["default"].componentWrapper,
      automation: "articleListingWrapper"
    }, /*#__PURE__*/_react["default"].createElement(_articleCards["default"], {
      data: componentData,
      theme: theme
    }));
  };
  return ArticleListing;
}(_react["default"].Component);
exports["default"] = ArticleListing;
ArticleListing.displayName = 'ArticleListing';
ArticleListing.defaultProps = {
  data: _articleListing2["default"],
  defaultData: _articleListing2["default"],
  theme: {}
};